import styled from "@emotion/styled";
import IconButton from "@mui/material/IconButton";

import {
  alignmentCssVariableValues,
  setFullViewportWidthBackgroundStyles,
  theme,
} from "shared/lib/styles";

export const Container = styled.div`
  position: relative;

  padding-inline: ${alignmentCssVariableValues.headerAlignmentPaddingInline};

  background: #00001f;

  ${theme.breakpoints.up("tablet")} {
    block-size: 50px;
  }
`;

export const FullWidthBackground = styled.div`
  ${setFullViewportWidthBackgroundStyles("inherit")}
`;

export const Content = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: flex-start;
  align-items: center;

  inline-size: 100%;
  block-size: 100%;
  padding-block: 12px;
`;

export const CloseButton = styled(IconButton)`
  inline-size: 25px;
  block-size: 25px;

  background: #33334b;

  svg {
    scale: 1.5;
  }

  path {
    fill: #ffffff;
  }
`;
